import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import TextInput from '../styled/TextInput';

const Control = styled.div`
  position: relative;
`;

const Input = styled(TextInput)`
  padding-right: 50px;
`;

const Button = styled.button`
  height: 100%;
  width: 37px;
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #ffffff;
  border: 1px solid #3e3a83;
  border-radius: 5px;
  background-color: #3e3a83;
  cursor: pointer;
  transition: 0.2s all;

  &:disabled {
    border-color: #b0a9f9;
    background-color: #b0a9f9;
    cursor: not-allowed;
  }
`;

const SearchBar = ({ prevTerm, onSubmit }) => {
  const [term, setTerm] = useState('');

  useEffect(() => {
    setTerm(prevTerm);
  }, [prevTerm]);

  const trimmedTerm = term.trim();

  const handleChange = (event) => {
    setTerm(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    onSubmit(trimmedTerm);
  };

  return (
    <form onSubmit={handleSubmit}>
      <Control>
        <Input
          aria-label="Search"
          placeholder="Search"
          value={term}
          onChange={handleChange}
        />
        <Button
          type="submit"
          disabled={trimmedTerm.length >= 1 && trimmedTerm.length <= 2}
        >
          <i className="icon-Search" />
        </Button>
      </Control>
    </form>
  );
};

SearchBar.propTypes = {
  prevTerm: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default SearchBar;
